import type { UUID } from '@cmg/common';
import type { CustomCellRendererProps } from '@cmg/data-grid';
import { Link, useParams } from 'react-router-dom';

import { useRoutes } from '../../../../../common/hooks/useRoutes/useRoutes';
import type { InvestorFirmFragment } from '../graphql/__generated__';

export function FirmNameCellRenderer({
  value,
  data,
}: Readonly<CustomCellRendererProps<InvestorFirmFragment, string>>) {
  const { crmIntegrationId } = useParams<{ crmIntegrationId?: UUID }>();

  const displayValue = value || '-';

  const { crmInvestorFirm } = useRoutes(crmIntegrationId);

  if (!data) {
    return <span>{displayValue}</span>;
  }

  return (
    <Link to={crmInvestorFirm.getUrlPath({ crmIntegrationId, firmId: data.id })}>
      {displayValue}
    </Link>
  );
}
